import { render, staticRenderFns } from "./AbonementDocumentTemplates.vue?vue&type=template&id=0c54c6f4&scoped=true&lang=pug&"
import script from "./AbonementDocumentTemplates.vue?vue&type=script&lang=js&"
export * from "./AbonementDocumentTemplates.vue?vue&type=script&lang=js&"
import style0 from "./AbonementDocumentTemplates.vue?vue&type=style&index=0&id=0c54c6f4&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c54c6f4",
  null
  
)

/* custom blocks */
import block0 from "./AbonementDocumentTemplates.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports